<div>
  <mat-card class="orgApp-config-card orgApp-config-card-ht">
    <mat-card-content class="orgApp-d-flex">
      <div>
        <mat-card
          class="orgApp-config-card-ht orgApp-config-card-sub orgApp-d-flex orgApp-flex-dir-col orgApp-justify-c-spc-btw"
        >
          @if (sharedDataService.showData) {
          <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-20">
            <mat-card-header>
              <div class="orgApp-gap-10 orgApp-d-flex">
                <div class="orgApp-config-logo orgApp-text-center">
                  @if(orgLogo){
                    <img mat-card-sm-image [src]="orgLogo" [fallbackImage]="noOrganizationLogo" alt="Logo" />
                  }
                  @else{
                    <ngx-skeleton-loader
                    class="orgApp-org-logo-img"
                    appearance="circle"
                    >
                  </ngx-skeleton-loader>
                  }
                </div>
                <div>
                  <mat-card-title>{{ orgDetails?.name }}</mat-card-title>
                  <mat-card-subtitle
                    ><a [href]="'mailto:' + orgDetails?.email">{{
                      orgDetails?.email
                    }}</a></mat-card-subtitle
                  >
                </div>
              </div>
            </mat-card-header>
            <mat-card-content class="orgApp-config-orgname">
              {{ orgDetails?.description }}
            </mat-card-content>
          </div>
          } @if (!sharedDataService.showData) {
          <div
            class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-12 orgApp-loader"
          >
            <mat-card-header>
              <mat-card-title-group class="orgApp-gap-8">
                <div>
                  <ngx-skeleton-loader
                    class="orgApp-loader-logo"
                    appearance="circle"
                  >
                  </ngx-skeleton-loader>
                </div>
                <div>
                  <mat-card-title class="orgApp-loader-title"
                    ><ngx-skeleton-loader></ngx-skeleton-loader
                  ></mat-card-title>
                  <mat-card-subtitle class="orgApp-loader-title"
                    ><ngx-skeleton-loader></ngx-skeleton-loader
                  ></mat-card-subtitle>
                </div>
              </mat-card-title-group>
            </mat-card-header>
            <mat-card-content class="orgApp-loader-title">
              <ngx-skeleton-loader></ngx-skeleton-loader>
            </mat-card-content>
          </div>
          } @if (sharedDataService.showData && canAccessToOrganisation) {
          <div>
            <mat-card-actions>
              <button
                mat-stroked-button
                class="orgApp-config-card-sub-btn"
                routerLink="/organization"
                (click)="manageOrg()"
              >
                {{ "toolbar.action.manage_org" | translate }}
              </button>
            </mat-card-actions>
          </div>
          }
        </mat-card>
      </div>
      <div class="orgApp-config-card-submenu-wrpr">
        @if (showLocData) {
        <div
          class="orgApp-config-card-sub orgApp-config-card-fit-content orgApp-config-loc-wrpr orgApp-config-loc-detail"
        >
          @for (location of locDetails; track location; let i = $index) {
          <div class="orgApp-config-card-fit-content">
            @if (location.active) {
            <button
              class="orgApp-config-card-btn"
              mat-menu-item
              [ngClass]="{
                'active active-config-item':
                  activeButtonIndex === i && menuStates[i]
              }"
              (click)="selectedLocation(location, i)"
            >
              <div class="orgApp-d-flex orgApp-gap-8 orgApp-align-i-center">
                <div
                  class="orgApp-d-flex orgApp-gap-8 orgApp-config-card-btn-div"
                >
                  @if (activeButtonIndex === i && menuStates[i]) {
                  <svg
                    width="16"
                    height="16"
                    class="orgApp-config-card-btn-svg"
                  >
                    <use xlink:href="#location-active"></use>
                  </svg>
                  } @if (activeButtonIndex !== i || !menuStates[i]) {
                  <svg
                    width="16"
                    height="16"
                    class="orgApp-config-card-btn-svg"
                  >
                    <use xlink:href="#location-inactive"></use>
                  </svg>
                  }

                  {{ location.name }}
                </div>
                <svg width="16" height="16">
                  <use
                    [attr.xlink:href]="menuStates[i] ? '#arrow-black-right' : '#arrow-black-down'">
                  </use>
                </svg>                
              </div></button
            >}
          </div>
          }
        </div>
        } @if (!showLocData) {
        <div class="orgApp-config-location-loader">
          @for (item of [].constructor(3); track item; let i=$index) {
          <div class="orgApp-loader-title">
            <ngx-skeleton-loader></ngx-skeleton-loader>
          </div>
          }
        </div>
        }
      </div>
      @if (showDropDown) {
      <div
        class="orgApp-d-flex orgApp-flex-dir-col orgApp-config-card-submenu orgApp-justify-c-center"
      >
      @if (isLoadingSubMenu) {
        <div class="orgApp-config-location-loader">
          @for (item of [].constructor(6); track item; let i=$index) {
          <div>
            <ngx-skeleton-loader  [theme]="{ width: (200 - (i * 20)) + 'px', height: '20px', 'margin-top': '12px' }"></ngx-skeleton-loader>
          </div>
          }
        </div>
      }@else {
        @for (item of filteredSubMenuItems; track item) {
        <button
          class="orgApp-config-card-submenu-btn"
          mat-menu-item
          [routerLink]="item.routerLink"
          (click)="onSelectSubMenuItem(item)"
        >
          {{
            "toolbar.action.configuration_action." + item.label | translate
          }}</button
        >}}
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
